export enum SHORTCUT {
  OPEN_PALETTE = "mod+k",
  NEW_THREAD = "mod+n",
}

// Bekaert users are on Windows 11 → show "Ctrl"; macOS (rare) → "⌘". The
// keyboard handlers accept both (metaKey || ctrlKey); only the hint differs.
const IS_MAC =
  typeof navigator !== "undefined" &&
  /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent || "");

export const MOD_KEY = IS_MAC ? "⌘" : "Ctrl";

export function shortcut(key: string): string {
  return IS_MAC ? `⌘${key}` : `Ctrl+${key}`;
}

export interface ShortcutDisplay {
  display: string;
  label: string;
}

export const SHORTCUT_LIST: readonly ShortcutDisplay[] = [
  { display: shortcut("K"), label: "Open command palette" },
  { display: shortcut("N"), label: "New thread" },
  { display: "/", label: "Search threads" },
  { display: "Enter", label: "Send message" },
  { display: "Shift + Enter", label: "New line in composer" },
  { display: "Esc", label: "Close drawer / modal" },
];
